import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuyerLoginComponent } from './pages/buyer-login/buyer-login.component';
// import { BuyerRegisterComponent } from './pages/buyer-register/buyer-register.component';
import { BuyerNewRegisterComponent } from './pages/buyer-new-register/buyer-new-register.component';

import { BuyerConfirmEmailComponent } from './pages/buyer-confirm-email/buyer-confirm-email.component';
import { BuyerForgetPasswordComponent } from './pages/buyer-forget-password/buyer-forget-password.component';
import { BuyerResetPasswordComponent } from './pages/buyer-reset-password/buyer-reset-password.component';
import { BuyerChangePasswordComponent } from './pages/buyer-change-password/buyer-change-password.component';

export const routes: Routes = [
  {
    path: 'login',
    component: BuyerLoginComponent,
    data: {
      title: 'Login to Your Account |BidxSell',
      description:
        'Access your bidxsell account to bid on horses, manage your purchases, and stay updated on auction results.',
    },
  },
  {
    path: 'forgot-password',
    component: BuyerForgetPasswordComponent,
    data: {
      title: 'Forgot Password | BidxSell',
      description:
        'Reset your BidxSell account password. Enter your email to receive password reset instructions.',
    },
  },
  {
    path: 'password-reset',
    component: BuyerResetPasswordComponent,
    data: {
      title: 'Reset Password | BidxSell',
      description:
        'Create a new password for your BidxSell account. Choose a strong, secure password.',
    },
  },
  {
    path: 'register',
    component: BuyerNewRegisterComponent,
    data: {
      title: 'Create Your Account | bidxsell',
      description:
        'Join our online horse auction platform and start bidding on your dream horse. Register now at bidxsell.',
    },
  },
  {
    path: 'verify-email',
    component: BuyerConfirmEmailComponent,
    data: {
      title: 'Verify Email Address | BidxSell',
      description:
        'Verify your email address to complete your BidxSell account setup and start bidding.',
    },
  },
  {
    path: 'change-password',
    component: BuyerChangePasswordComponent,
    data: {
      title: 'Change Password | BidxSell Account Settings',
      description:
        'Update your BidxSell account password for enhanced security. Keep your account safe.',
    },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
    data: {
      title: 'Authentication | BidxSell',
      description:
        'Access your BidxSell account or create a new one to start bidding on horses.',
    },
  },
];
